// import { fetch } from 'whatwg-fetch';
import 'whatwg-fetch';
import _ from 'lodash';

import { FIREBASE_CONFIG } from '../config';
import { getIdToken } from './firebase';

export const post = (path, params, json = true) => {
  return getIdToken().then((token) => {
    const url = `${FIREBASE_CONFIG.apiUrl}${path}`;
    const auth = token ? { Authorization: `Bearer ${token}` } : {};
    const params2 = _.assign(params, { method: 'POST', headers: _.assign(auth, params.headers) });

    return fetch(url, params2)
      .then((resp) => {
        if (!json) {
          return resp;
        }

        if (!resp.ok) {
          return resp.json().then((json) => {
            console.error('error json', json);
            if (json.errors && json.errors.length >= 1) {
              throw new Error(json.errors[0].detail);
            }

            throw new Error('Unknown error');
          });
        }

        return resp.json();
      });
  });

};

export const postNoAuth = (path, params, json = true) => {
  const url = `${FIREBASE_CONFIG.apiUrl}${path}`;
  const params2 = _.assign(params, { method: 'POST' });

  return fetch(url, params2)
    .then((resp) => {
      if (!json) {
        return resp;
      }

      if (!resp.ok) {
        return resp.json().then((json) => {
          console.error('error json', json);
          if (json.errors && json.errors.length >= 1) {
            throw new Error(json.errors[0].detail);
          }

          throw new Error('Unknown error');
        });
      }

      return resp.json();
    });
};

export const get = (path, params = {}, json = true) => {
  return getIdToken().then((token) => {
    const url = `${FIREBASE_CONFIG.apiUrl}${path}`;
    const auth = token ? { Authorization: `Bearer ${token}` } : {};
    const params2 = _.assign(params, { method: 'GET', headers: _.assign(auth, params.headers) });
    console.log('params2', params2);

    return fetch(url, params2)
      .then((resp) => {
        if (!json) {
          return resp;
        }

        if (!resp.ok) {
          return resp.json().then((json) => {
            console.error('error json', json);
            if (json.errors && json.errors.length >= 1) {
              throw new Error(json.errors[0].detail);
            }

            throw new Error('Unknown error');
          });
        }

        return resp.json();
      });
  });

};

// export const post = (path, params) => firebase.fetchUser()
//   .then((user) => {
//     if (user) {
//       const token = user.getToken();
//       return token;
//     }
//
//     return null;
//   })
//   .then((token) => {
//     const url = `${FIREBASE_CONFIG.apiUrl}${path}`;
//     const auth = token ? {Authorization: `Bearer ${token}`} : {};
//     const params2 = _.assign(params, {headers: _.assign(params.headers, auth)});
//     console.log('params2', params2);
//     return fetch(url, params2);
//   })
//   .then((resp) => resp.json());



// WEBPACK FOOTER //
// ./src/utils/rest.js